// services/insurance.js — осигурителните параметри по години
// (config/insurance.config.json): МРЗ, максимален осигурителен доход и
// ставките за лицата без трудово правоотношение (ПРОМТ-21).
//
// Числата са в конфигурацията, а не в кода, за да се сменят всяка година
// без програмист. Обвивката е CJS по същата причина като services/siddo.js:
// Vite и чистият Node ESM (jsdom тестовете) четат JSON различно, а require
// работи и в двата.

const config = require('../config/insurance.config.json');

// Периодът, в който попада датата. Дата извън описаните периоди е грешка,
// не тихо подразбиране — иначе калкулаторът би смятал 2027 г. с таваните
// на 2026 г. и никой не би забелязал.
function periodFor(dateIso) {
  const d = String(dateIso || '').slice(0, 10);
  const p = /^\d{4}-\d{2}-\d{2}$/.test(d) ? config.periods.find((x) => x.from <= d && d <= x.to) : null;
  if (!p) {
    const shown = d ? d.split('-').reverse().join('.') : '(няма дата)';
    throw new Error('Няма параметри за осигуровките към ' + shown + ' — допълнете config/insurance.config.json');
  }
  return p;
}

const rates = config.rates;
const meta = config._meta;

module.exports = { periodFor, rates, meta };
